import axiosFlow from '../axios/axiosFlow'

export default class AgenteService {
  static async getDisponibilidades(agenteId, diaSemana) {
    const params = new URLSearchParams()

    if (diaSemana) {
      params.append('DiaSemana', diaSemana)
    }

    return axiosFlow.get(`agentes/${agenteId}/disponibilidades?${params}`).then(res => res.data.data)
  }

  static async getPeriodosDeDisponibilidadesPorDia() {
    return axiosFlow.get('agentes/disponibilidades/periodos-dia').then(res => res.data.data)
  }

  static async getIndisponibilidades(agenteId) {
    return axiosFlow.get(`agentes/${agenteId}/indisponibilidades`).then(res => res.data.data.items)
  }

  static async getMotivosIndisponibilidades() {
    return axiosFlow.get('agentes/indisponibilidades/motivos').then(res => res.data.data)
  }

  static async criarDisponibilidadeAgente(agenteId, body) {
    return axiosFlow.post(`agentes/${agenteId}/disponibilidades`, body)
  }

  static async atualizarDisponibilidadeAgente(agenteId, disponibilidadeId, body) {
    return axiosFlow.put(`agentes/${agenteId}/disponibilidades/${disponibilidadeId}`, body)
  }

  static async excluirDisponibilidadeAgente(agenteId, disponibilidadeId) {
    return axiosFlow.delete(`agentes/${agenteId}/disponibilidades/${disponibilidadeId}`)
  }

  static async criarIndisponibilidadeAgente(agenteId, body) {
    return axiosFlow.post(`agentes/${agenteId}/indisponibilidades`, body)
  }

  static async atualizarIndisponibilidadeAgente(agenteId, indisponibilidadeId, body) {
    return axiosFlow.put(`agentes/${agenteId}/indisponibilidades/${indisponibilidadeId}`, body)
  }

  static async excluirIndisponibilidadeAgente(agenteId, indisponibilidadeId) {
    return axiosFlow.delete(`agentes/${agenteId}/indisponibilidades/${indisponibilidadeId}`)
  }
}
